<template>
  <header>
    <div
      id="header-sticky"
      :class="`${
        isSticky
          ? 'header__area header__transparent header__padding sticky'
          : 'header__area header__transparent header__padding'
      } ${header__white && header__white}`"
    >
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-2 col-sm-4 col-6">
            <div class="header__left d-flex align-items-center">
              <div class="logo">
                <router-link to="/">
                  <h6
                    class="mb-0 d-flex align-items-end"
                    :style="isSticky ? 'color: #0e1133' : 'color: white'"
                  >
                    <img
                      width="100"
                      height="100"
                      src="../../assets/img/logotip1.png"
                      alt=""
                    />
                    <p
                      class="ml-2 d-none"
                      :style="isSticky ? 'color: #0e1133' : 'color: white'"
                    >
                      Togʻ-kon va geologiya sohasi <br />
                      xodimlari malakasini oshirish instituti
                    </p>
                  </h6>
                </router-link>
              </div>
              <div class="header__category d-none">
                <nav>
                  <ul>
                    <li>
                      <router-link
                        to="/courses"
                        class="cat-menu d-flex align-items-center"
                      >
                        <div class="cat-dot-icon d-inline-block">
                          <svg viewBox="0 0 276.2 276.2">
                            <g>
                              <g>
                                <path
                                  class="cat-dot"
                                  d="M33.1,2.5C15.3,2.5,0.9,17,0.9,34.8s14.5,32.3,32.3,32.3s32.3-14.5,32.3-32.3S51,2.5,33.1,2.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M137.7,2.5c-17.8,0-32.3,14.5-32.3,32.3s14.5,32.3,32.3,32.3c17.8,0,32.3-14.5,32.3-32.3S155.5,2.5,137.7,2.5    z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M243.9,67.1c17.8,0,32.3-14.5,32.3-32.3S261.7,2.5,243.9,2.5S211.6,17,211.6,34.8S226.1,67.1,243.9,67.1z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M32.3,170.5c17.8,0,32.3-14.5,32.3-32.3c0-17.8-14.5-32.3-32.3-32.3S0,120.4,0,138.2S14.5,170.5,32.3,170.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M136.8,170.5c17.8,0,32.3-14.5,32.3-32.3c0-17.8-14.5-32.3-32.3-32.3c-17.8,0-32.3,14.5-32.3,32.3    C104.5,156.1,119,170.5,136.8,170.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M243,170.5c17.8,0,32.3-14.5,32.3-32.3c0-17.8-14.5-32.3-32.3-32.3s-32.3,14.5-32.3,32.3    C210.7,156.1,225.2,170.5,243,170.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M33,209.1c-17.8,0-32.3,14.5-32.3,32.3c0,17.8,14.5,32.3,32.3,32.3s32.3-14.5,32.3-32.3S50.8,209.1,33,209.1z    "
                                />
                                <path
                                  class="cat-dot"
                                  d="M137.6,209.1c-17.8,0-32.3,14.5-32.3,32.3c0,17.8,14.5,32.3,32.3,32.3c17.8,0,32.3-14.5,32.3-32.3    S155.4,209.1,137.6,209.1z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M243.8,209.1c-17.8,0-32.3,14.5-32.3,32.3c0,17.8,14.5,32.3,32.3,32.3c17.8,0,32.3-14.5,32.3-32.3    S261.6,209.1,243.8,209.1z"
                                />
                              </g>
                            </g>
                          </svg>
                        </div>
                        <span>Category</span>
                      </router-link>
                      <ul class="cat-submenu">
                        <li>
                          <router-link to="/course-details"
                            >English Learning</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Web Development</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Logo Design</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Motion Graphics</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Video Edition</router-link
                          >
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div class="col-xxl-10 col-xl-9 col-lg-8 col-md-10 col-sm-8 col-6">
            <div
              class="header__right d-flex justify-content-end align-items-center"
            >
              <div class="main-menu main-menu-3">
                <nav id="mobile-menu" class="d-none d-xl-block">
                  <ul>
                    <li
                      v-for="(item, index) in formattedMenu"
                      :key="index"
                      class="mx-3"
                      :class="{
                        active: openedMenu === index,
                        'has-dropdown': item.children && item.children.length,
                      }"
                    >
                      <template v-if="item.children && item.children.length">
                        <a
                          @click="toggleMenu(index)"
                          :style="isSticky ? 'color: #0e1133' : 'color: white'"
                          >{{
                            getName({
                              nameUz: item.title_uz,
                              nameRu: item.title_ru,
                              nameEn: item.title_en,
                            })
                          }}</a
                        >
                        <ul class="submenu">
                          <li
                            v-for="(child, childIndex) in item.children
                              .filter((c) => c.status === true)
                              .sort((a, b) => a.position - b.position)"
                            :key="childIndex"
                            :class="{
                              'has-dropdown':
                                child.children && child.children.length,
                            }"
                          >
                            <template
                              v-if="child.children && child.children.length"
                            >
                              <a>
                                {{
                                  getName({
                                    nameUz: child.title_uz,
                                    nameRu: child.title_ru,
                                    nameEn: child.title_en,
                                  })
                                }}
                                <span class="arrow">›</span>
                              </a>
                              <ul class="submenu submenu--nested">
                                <li
                                  v-for="(
                                    grandChild, grandIndex
                                  ) in child.children
                                    .filter((c) => c.status === true)
                                    .sort((a, b) => a.position - b.position)"
                                  :key="grandIndex"
                                  :class="{
                                    'has-dropdown':
                                      grandChild.children &&
                                      grandChild.children.length,
                                  }"
                                >
                                  <template
                                    v-if="
                                      grandChild.children &&
                                      grandChild.children.length
                                    "
                                  >
                                    <a
                                      >{{
                                        getName({
                                          nameUz: grandChild.title_uz,
                                          nameRu: grandChild.title_ru,
                                          nameEn: grandChild.title_en,
                                        })
                                      }}
                                      <span class="arrow">›</span>
                                    </a>
                                    <ul class="submenu submenu--nested">
                                      <li
                                        v-for="(
                                          deepChild, deepIndex
                                        ) in grandChild.children
                                          .filter((c) => c.status === true)
                                          .sort(
                                            (a, b) => a.position - b.position,
                                          )"
                                        :key="deepIndex"
                                      >
                                        <router-link :to="`/${deepChild.slug}`">
                                          {{
                                            getName({
                                              nameUz: deepChild.title_uz,
                                              nameRu: deepChild.title_ru,
                                              nameEn: deepChild.title_en,
                                            })
                                          }}
                                        </router-link>
                                      </li>
                                    </ul>
                                  </template>
                                  <template v-else>
                                    <router-link :to="`/${grandChild.slug}`">
                                      {{
                                        getName({
                                          nameUz: grandChild.title_uz,
                                          nameRu: grandChild.title_ru,
                                          nameEn: grandChild.title_en,
                                        })
                                      }}
                                    </router-link>
                                  </template>
                                </li>
                              </ul>
                            </template>

                            <template v-else>
                              <router-link :to="`/${child.slug}`">
                                {{
                                  getName({
                                    nameUz: child.title_uz,
                                    nameRu: child.title_ru,
                                    nameEn: child.title_en,
                                  })
                                }}
                              </router-link>
                            </template>
                          </li>
                        </ul>
                      </template>

                      <template v-else>
                        <router-link :to="`/${item.slug}`">
                          {{
                            getName({
                              nameUz: item.title_uz,
                              nameRu: item.title_ru,
                              nameEn: item.title_en,
                            })
                          }}
                        </router-link>
                      </template>
                    </li>

                    <!-- <li v-for="(item, index) in formattedMenu" :key="index" class="menu-item-has-children" :class="{ active: openedMenu === index, 'has-droupdown': item.children && item.children.length}">
                        <template v-if="item.children && item.children.length">
                          <a @click="toggleMenu(index)">{{ getName({ nameUz: item.title_uz, nameRu: item.title_ru, nameEn: item.title_en }) }}</a>
                          <ul class="sub-menu" :class="{ active: openedMenu === index }">
                            <li v-for="(child, childIndex) in item.children.filter(c => c.status === true).sort((a, b) => a.position - b.position)" :key="childIndex">
                              <router-link :to="`/${child.slug}`">{{ getName({ nameUz: child.title_uz, nameRu: child.title_ru, nameEn: child.title_en }) }}</router-link>
                            </li>
                          </ul>
                        </template>

                        <template v-else>
                          <router-link :to="`/${item.slug}`">{{ getName({ nameUz: item.title_uz, nameRu: item.title_ru, nameEn: item.title_en }) }} test</router-link>
                        </template>
                      </li> -->

                    <!-- <li v-for="(vm, index) in formattedMenu" :key="index" class="mx-3" :class="vm.children.length > 0 ? 'has-dropdown' : ''">
                      <router-link :to="vm.children.length > 0 ? '#' : `/${vm.slug}`">
                        {{ vm.title_uz }}
                      </router-link>
                      <ul class="submenu" v-if="vm.children.length > 0">
                        <li v-for="(item, index1) in vm.children" :key="index1">
                          <router-link :to="`/${item.slug}`">{{ item?.title_uz }}</router-link>
                        </li>
                      </ul>
                    </li> -->
                    <li class="has-dropdown d-none">
                      <router-link to="#">{{
                        $t("navbar.activity")
                      }}</router-link>
                      <ul class="submenu">
                        <!--                        blog-->
                        <li>
                          <router-link to="/">{{
                            $t("navbar.hamkorlik")
                          }}</router-link>
                        </li>
                        <!--                        blog-details-->
                        <li>
                          <router-link to="/raqamlashtirish">{{
                            $t("navbar.raqamlash")
                          }}</router-link>
                        </li>
                        <li>
                          <router-link to="/">{{
                            $t("navbar.aql")
                          }}</router-link>
                        </li>
                        <li>
                          <router-link to="/faq">{{
                            $t("navbar.faq")
                          }}</router-link>
                        </li>
                      </ul>
                    </li>
                    <li class="has-dropdown d-none">
                      <!--                      courses-->
                      <router-link to="/">{{
                        $t("service.title")
                      }}</router-link>
                      <ul class="submenu">
                        <li>
                          <router-link to="/news">{{
                            $t("navbar.news")
                          }}</router-link>
                        </li>
                        <!--                        instructor-->
                        <li>
                          <router-link to="/events">{{
                            $t("event.mainTitle1")
                          }}</router-link>
                        </li>
                        <!--                        instructor-details-->
                        <li>
                          <router-link to="/fotos">{{
                            $t("actions.fotoGalerea")
                          }}</router-link>
                        </li>
                        <!--                        event-details-->
                        <li>
                          <router-link to="/videos">{{
                            $t("actions.videoList")
                          }}</router-link>
                        </li>
                        <!--                        cart-->
                        <!--                        <li><router-link to="/">{{$t('service.ui')}}</router-link></li>-->
                        <!--                        checkout-->
                        <!--                        <li><router-link to="/">{{$t('service.crm')}}</router-link></li>-->
                      </ul>
                    </li>
                    <li class="has-dropdown d-none">
                      <router-link to="/">{{
                        $t("navbar.product")
                      }}</router-link>
                      <ul class="submenu">
                        <li>
                          <router-link to="/products/fairTech"
                            >Fair Tech</router-link
                          >
                        </li>
                        <!--                        products/fairPrice-->
                        <li><router-link to="/">Fair Price</router-link></li>
                        <!--                        products/pharmInfo-->
                        <li><router-link to="/">Pharm Info</router-link></li>
                        <!--                        products/productInfo-->
                        <li><router-link to="/">Product Info</router-link></li>
                        <!--                        products/marketplace-->
                        <li><router-link to="/">Marketplace</router-link></li>
                      </ul>
                    </li>
                    <li class="d-none">
                      <router-link to="/contact">{{
                        $t("navbar.contact")
                      }}</router-link>
                    </li>
                    <li class="has-dropdown">
                      <router-link to="#">
                        {{
                          locate == "uz"
                            ? "O'zbek"
                            : locate == "ru"
                            ? "Русский"
                            : locate == "en"
                            ? "English"
                            : "Ўзбек"
                        }}
                      </router-link>
                      <ul class="submenu">
                        <li
                          style="cursor: pointer"
                          v-for="(vm, index) in items"
                          :key="index"
                          @click="exchange(vm.value)"
                        >
                          <a href="#">{{ vm.state }}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="header__search p-relative ml-50 d-none d-md-none">
                <form action="#">
                  <input type="text" placeholder="Search..." />
                  <button type="submit"><i class="fad fa-search"></i></button>
                </form>
              </div>
              <div class="sidebar__menu d-xl-none">
                <div
                  @click="handleSidebar"
                  class="sidebar-toggle-btn ml-30"
                  id="sidebar-toggle"
                >
                  <span class="line"></span>
                  <span class="line"></span>
                  <span class="line"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- cart mini area start -->
  <div class="cartmini__area">
    <div
      :class="`${
        showMiniCart ? 'cartmini__wrapper opened' : 'cartmini__wrapper'
      }`"
    >
      <div class="cartmini__title">
        <h4>Shopping cart</h4>
      </div>
      <div @click="handleCartClose" class="cartmini__close">
        <button type="button" class="cartmini__close-btn">
          <i class="fal fa-times"></i>
        </button>
      </div>
      <div class="cartmini__widget">
        <div class="cartmini__inner">
          <ul>
            <li>
              <div class="cartmini__thumb">
                <a href="#">
                  <img src="../../assets/img/course/sm/cart-1.jpg" alt="" />
                </a>
              </div>
              <div class="cartmini__content">
                <h5>
                  <a href="#">Strategy law and organization Foundation </a>
                </h5>
                <div class="product-quantity mt-10 mb-10">
                  <span
                    @click="handleDecreaseValue('valueOne')"
                    class="cart-minus"
                    >-</span
                  >
                  <input class="cart-input" type="text" v-model="value" />
                  <span
                    @click="handleIncreaseValue('valueOne')"
                    class="cart-plus"
                    >+</span
                  >
                </div>
                <div class="product__sm-price-wrapper">
                  <span class="product__sm-price">$46.00</span>
                </div>
              </div>
              <a href="#" class="cartmini__del"><i class="fal fa-times"></i></a>
            </li>
            <li>
              <div class="cartmini__thumb">
                <a href="#">
                  <img src="../../assets/img/course/sm/cart-2.jpg" alt="" />
                </a>
              </div>
              <div class="cartmini__content">
                <h5><a href="#">Fundamentals of music theory Learn new</a></h5>
                <div class="product-quantity mt-10 mb-10">
                  <span
                    @click="handleDecreaseValue('valueTwo')"
                    class="cart-minus"
                    >-</span
                  >
                  <input class="cart-input" type="text" v-model="valueTwo" />
                  <span
                    @click="handleIncreaseValue('valueTwo')"
                    class="cart-plus"
                    >+</span
                  >
                </div>
                <div class="product__sm-price-wrapper">
                  <span class="product__sm-price">$32.00</span>
                </div>
              </div>
              <a href="#" class="cartmini__del"><i class="fal fa-times"></i></a>
            </li>
            <li>
              <div class="cartmini__thumb">
                <a href="#">
                  <img src="../../assets/img/course/sm/cart-3.jpg" alt="" />
                </a>
              </div>
              <div class="cartmini__content">
                <h5>
                  <a href="#">Strategy law and organization Foundation </a>
                </h5>
                <div class="product-quantity mt-10 mb-10">
                  <span
                    @click="handleDecreaseValue('valueThree')"
                    class="cart-minus"
                    >-</span
                  >
                  <input class="cart-input" type="text" v-model="valueThree" />
                  <span
                    @click="handleIncreaseValue('valueThree')"
                    class="cart-plus"
                    >+</span
                  >
                </div>
                <div class="product__sm-price-wrapper">
                  <span class="product__sm-price">$62.00</span>
                </div>
              </div>
              <a href="#" class="cartmini__del"><i class="fal fa-times"></i></a>
            </li>
          </ul>
        </div>
        <div class="cartmini__checkout">
          <div class="cartmini__checkout-title mb-30">
            <h4>Subtotal:</h4>
            <span>$113.00</span>
          </div>
          <div class="cartmini__checkout-btn">
            <router-link to="/cart" class="e-btn e-btn-border mb-10 w-100">
              <span></span> view cart</router-link
            >
            <router-link to="/checkout" class="e-btn w-100">
              <span></span> checkout</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    @click="handleCartClose"
    :class="[showMiniCart ? 'body-overlay opened' : 'body-overlay']"
  ></div>
  <!-- cart mini area end -->

  <!-- sidebar area start -->
  <div
    :class="`${showSidebar ? 'sidebar__area sidebar-opened' : 'sidebar__area'}`"
  >
    <div class="sidebar__wrapper">
      <div @click="handleSidebarClose" class="sidebar__close">
        <button class="sidebar__close-btn" id="sidebar__close-btn">
          <span><i class="fal fa-times"></i></span>
          <span>close</span>
        </button>
      </div>
      <div class="sidebar__content">
        <div class="logo">
          <router-link to="/">
            <img
              width="100"
              height="100"
              src="../../assets/img/logotip1.png"
              alt=""
            />
          </router-link>
        </div>

        <div class="side-info-content sidebar-menu mm-menu">
          <ul>
            <li
              v-for="(item, index) in formattedMenu"
              :key="index"
              class="menu-item-has-children"
              :class="{
                active: openedMenu === index,
                'has-droupdown': item.children && item.children.length,
              }"
            >
              <template v-if="item.children && item.children.length">
                <a @click="toggleMenu(index)">{{
                  getName({
                    nameUz: item.title_uz,
                    nameRu: item.title_ru,
                    nameEn: item.title_en,
                  })
                }}</a>
                <ul class="sub-menu" :class="{ active: openedMenu === index }">
                  <li
                    v-for="(child, childIndex) in item.children
                      .filter((c) => c.status === true)
                      .sort((a, b) => a.position - b.position)"
                    :key="childIndex"
                  >
                    <router-link :to="`/${child.slug}`">{{
                      getName({
                        nameUz: child.title_uz,
                        nameRu: child.title_ru,
                        nameEn: child.title_en,
                      })
                    }}</router-link>
                  </li>
                </ul>
              </template>

              <template v-else>
                <router-link :to="`/${item.slug}`"
                  >{{
                    getName({
                      nameUz: item.title_uz,
                      nameRu: item.title_ru,
                      nameEn: item.title_en,
                    })
                  }}
                  test</router-link
                >
              </template>
            </li>
          </ul>
          <!-- <ul>
            <li v-for="(item, index) in formattedMenu" :key="index" class="menu-item-has-children"
              :class="{ active: openedMenu === index, 'has-droupdown':(item.children && item.children.length) }">

              <template v-if="item.children && item.children.length">
                <a @click="toggleMenu(index)">{{ item.title_uz }}</a>
                <ul class="sub-menu" :class="{ active: openedMenu === index }">
                  <li v-for="(child, childIndex) in item.children" :key="childIndex">
                    <router-link :to="`/${child.slug}`">{{ child.title_uz }}</router-link>
                  </li>
                </ul>
              </template>

              <template v-else>
                <router-link :to="`/${item.slug}`"> {{ item.title_uz }}</router-link>
              </template>

            </li>
          </ul> -->

          <!-- <ul>
            <li v-for="(vm, index) in formattedMenu" :key="index" class="mx-3"
              :class="vm.children.length > 0 ? 'has-dropdown' : ''">
              <router-link :to="vm.children.length > 0 ? '#' : `/${vm.slug}`">
                {{ vm.title_uz }}
              </router-link>
              <ul class="submenu" v-if="vm.children.length > 0">
                <li v-for="(item, index1) in vm.children" :key="index1">
                  <router-link :to="`/${item.slug}`">{{ item?.title_uz }}</router-link>
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li class="menu-item-has-children has-droupdown"
              v-bind:class="[menuOption.homeDropdown === true ? 'active' : '']">
              <a @click="menuOption.homeDropdown = !menuOption.homeDropdown">Home</a>
              <ul class="sub-menu" :class="[menuOption.homeDropdown === true ? 'active' : '',]">
                <li>
                  <router-link to="/home">Home Style 1</router-link>
                </li>
                <li>
                  <router-link to="/home-two">Home Style 2</router-link>
                </li>
                <li>
                  <router-link to="/home-three">Home Style 3</router-link>
                </li>
              </ul>
            </li>


            <li class="menu-item-has-children has-droupdown"
              :class="[menuOption.coursesDropdown === true ? 'active' : '',]">
              <a @click="menuOption.coursesDropdown = !menuOption.coursesDropdown">Courses</a>
              <ul class="sub-menu" :class="[menuOption.coursesDropdown === true ? 'active' : '',]">
                <li>
                  <router-link to="/courses">Courses</router-link>
                </li>
                <li>
                  <router-link to="/courses-list">Course List</router-link>
                </li>
                <li>
                  <router-link to="/courses-sidebar">Course sidebar
                  </router-link>
                </li>
                <li>
                  <router-link to="/course-details">Course Details
                  </router-link>
                </li>
              </ul>
            </li>

            <li class="menu-item-has-children has-droupdown"
              :class="[menuOption.blogDropdown === true ? 'active' : '']">

              <a v-on:click="menuOption.blogDropdown = !menuOption.blogDropdown">Blog</a>
              <ul class="sub-menu" :class="[menuOption.blogDropdown === true ? 'active' : '',]">
                <li>
                  <router-link to="/blog">Blog</router-link>
                </li>
                <li>
                  <router-link to="/blog-details">Blog Details</router-link>
                </li>
              </ul>
            </li>


            <li class="menu-item-has-children has-droupdown"
              :class="[menuOption.pagesDropDown === true ? 'active' : '',]">
              <a @click="menuOption.pagesDropDown = !menuOption.pagesDropDown">Pages</a>
              <ul class="sub-menu" :class="[menuOption.pagesDropDown === true ? 'active' : '',]">
                <li><router-link to="/about">About</router-link></li>
                <li><router-link to="/instructor">Instructor</router-link></li>
                <li>
                  <router-link to="/instructor-details">
                    Instructor Details</router-link>
                </li>
                <li><router-link to="/event-details">Event Details</router-link></li>
                <li><router-link to="/cart">My Cart</router-link></li>
                <li><router-link to="/checkout">Checkout</router-link></li>
                <li><router-link to="/login">Sign In</router-link></li>
                <li><router-link to="/register">Sign Up</router-link></li>
                <li><router-link to="/errorPage">Error</router-link></li>
              </ul>
            </li>

            <li>
              <router-link to="/contact" class="border-0">Contact</router-link>
            </li>

          </ul> -->
        </div>
      </div>
    </div>
  </div>
  <div
    @click="handleSidebarClose"
    :class="[showSidebar ? 'body-overlay opened' : 'body-overlay']"
  ></div>
  <!-- sidebar area end -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BlogMixin from "../../mixins/blogMixin";

export default {
  name: "HomeHeader",
  mixins: [BlogMixin],
  props: {
    header__white: String,
  },
  data() {
    return {
      locate: localStorage.getItem("locale") || "uz",
      isSticky: false,
      openedMenu: null,
      showMiniCart: false,
      showSidebar: false,
      value: 1,
      valueTwo: 1,
      valueThree: 1,
      menuOption: {
        menuShow: false,
        menuSearch: false,
        homeDropdown: false,
        coursesDropdown: false,
        pagesDropDown: false,
        blogDropdown: false,
        aboutDropdown: false,
      },
      items: [
        { flag: "lat", state: "O'zbek", value: "uz", appear: true },
        // { flag: "crill", state: "Ўзбек", value: "uz", appear: true },
        { flag: "russia", state: "Русский", value: "ru", appear: true },
        { flag: "english", state: "English", value: "en", appear: true },
      ],
    };
  },

  created() {
    this.getMenu();
  },

  computed: {
    ...mapGetters("menu", ["menu"]),
    //    buildHierarchy() {
    //  const menuMap = new Map();
    //  this.menu.forEach(menu => {
    //   menu.children = [];
    //    menuMap.set(menu.id, menu);
    //   });
    //   this.menu.forEach(menu => {
    //   if (menu.parent !== null) {
    //   const parentMenu = menuMap.get(menu.parent);
    //   if (parentMenu) {
    //     parentMenu.children.push(menu);
    //   }
    //     }
    //   });
    //   const vm = this.menu.filter(menu => menu.parent === null);
    //   const topLevelMenus = vm.sort((a, b) => a.position - b.position);
    //     return topLevelMenus;
    // },

    formattedMenu() {
      const menuMap = new Map();

      this.menu.forEach((item) => {
        menuMap.set(item.id, { ...item, children: [] });
      });

      this.menu.forEach((item) => {
        if (item.parent !== null) {
          const parent = menuMap.get(item.parent);
          if (parent) {
            parent.children.push(menuMap.get(item.id));
          }
        }
      });

      return [...menuMap.values()]
        .filter((item) => item.parent === null && item.status === true)
        .sort((a, b) => a.position - b.position);
    },
    // formattedMenu() {
    //   const map = {};
    //   const tree = [];
    //   this.menu.forEach(item => {
    //     map[item.id] = { ...item, children: [] };
    //   });
    //   this.menu.forEach(item => {
    //     if (item.parent !== null) {
    //       if (map[item.parent]) {
    //         map[item.parent].children.push(map[item.id]);
    //       }
    //     } else {
    //       tree.push(map[item.id]);
    //     }
    //   });
    //   return tree.sort((a, b) => a.position - b.position);
    // }
  },

  methods: {
    ...mapActions("menu", ["getMenu"]),

    toggleMenu(index) {
      this.openedMenu = this.openedMenu === index ? null : index;
    },

    exchange(locale = "uz") {
      localStorage.setItem("locale", locale);
      this.$i18n.locale = locale;
      this.locate = localStorage.getItem("locale");
    },
    handleSticky() {
      if (window.scrollY > 80) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    handleMiniCart() {
      this.showMiniCart = true;
    },
    handleCartClose() {
      this.showMiniCart = false;
    },
    handleSidebar() {
      this.showSidebar = true;
    },
    handleSidebarClose() {
      this.showSidebar = false;
    },
    handleIncreaseValue(value) {
      if (value === "valueOne") {
        this.value++;
      }
      if (value === "valueTwo") {
        this.valueTwo++;
      }
      if (value === "valueThree") {
        this.valueThree++;
      }
    },
    handleDecreaseValue(value) {
      if (value === "valueOne" && this.value > 0) {
        this.value--;
      }
      if (value === "valueTwo" && this.valueTwo > 0) {
        this.valueTwo--;
      }
      if (value === "valueThree" && this.valueThree > 0) {
        this.valueThree--;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleSticky);
  },
};
</script>
<style scoped>
::v-deep .main-menu ul li .submenu {
  position: absolute;
  left: -96px;
}

.menu-item-has-children {
  display: block !important;
}

.menu-item-has-children .sub-menu,
.menu-item-has-children .submenu {
  position: static !important;
  width: 100% !important;
  opacity: 1 !important;
  visibility: visible !important;
  box-shadow: none !important;
  display: none;
}

.menu-item-has-children.active .sub-menu,
.menu-item-has-children.active .submenu {
  display: block;
}

.menu-item-has-children .sub-menu li,
.menu-item-has-children .submenu li {
  display: block;
  width: 100%;
}
/* Nested submenu - hover bilan o'ngga chiqadi */
.submenu--nested {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  min-width: 220px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  z-index: 999;
}

.has-dropdown {
  position: relative;
}

.has-dropdown:hover > .submenu--nested {
  display: block;
}

.arrow {
  float: right;
  font-style: normal;
}
</style>
